import React, { useState } from 'react';
import Card from 'components/Layout/Card';
import TabLayout from 'components/Layout/TabLayout';
import EventCertificates from './TabComponents/EventCertificates';

const CertificateManagement = () => {
  const tabs = [
    { key: 'event-certificates', label: 'Event Certificates' },
  ];
  const [tabType, setTabType] = useState('event-certificates');

  return (
    <>
      <Card className="d-flex align-items-center br-10 mb-3">
        <div className="cps-24 cpt-7 cpb-7">
          <TabLayout
            tabs={tabs}
            activeKey={tabType}
            onChange={setTabType}
            variant="background"
          />
        </div>
      </Card>

      <div>
        {tabType === 'event-certificates' && <EventCertificates />}
      </div>
    </>
  );
};

export default CertificateManagement;
